module.exports = __webpack_public_path__ + "img/settings.ec23fc06.svg";